const containerCls = "_n29cra9b1k";
const canvasCls = "_n29c1tbw4nm";

export { canvasCls, containerCls };
import "./LegacyCanvasShape.style.linaria.module.css";
//# sourceMappingURL=LegacyCanvasShape.style.js.map
